import {Component, OnInit, ViewContainerRef} from '@angular/core';

import {LayoutMgrService} from '../../services/layout-mgr/layout-mgr.service';
import {triggerDetailPopup, triggerNotiPopup} from '../../defines/client.const';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-common-popups',
  templateUrl: './common-popups.component.html',
  styleUrls: ['./common-popups.component.scss'],
  animations: [
    triggerDetailPopup,
    triggerNotiPopup,
  ],
})
export class CommonPopupsComponent implements OnInit {

  constructor(
    private vcRef: ViewContainerRef,
    public lm: LayoutMgrService,
  ) {
  }

  ngOnInit(): void {
    this.lm.vcRef = this.vcRef;
  }

}
